import RecipesScreen from "./components/recipe_screen";
function App() {
  return <RecipesScreen />;
}

export default App;
